module.exports = __webpack_public_path__ + "static/media/img_45.c043acf9.png";